<template>
    <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
        <page-navigate></page-navigate>
        <div class="cn cn-font-family">
            <section class="section1">
                <h1 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.EA交易与指标') }}</h1>
                <p class="p1">
                    {{ $t('Tools.EBC独家精选的MT4') }}
                </p>
            </section>
            <section class="section2">
                <img class="section2-img" src="../assets/image/tools/section2_bg.jpg" alt="" />
                <div class="section2-content">
                    <div class="section2-item">
                        <img class="section2-item-icon" src="../assets/image/tools/section2_icon1.svg" alt="" />
                        <p class="p1">
                            {{ $t('Tools.EBCTurbo账户分析系统') }}
                        </p>
                    </div>
                    <div class="section2-item">
                        <img class="section2-item-icon" src="../assets/image/tools/section2_icon2.svg" alt="" />
                        <p class="p1"> {{ $t('Tools.实用型技术指标集') }}</p>
                    </div>
                    <div class="section2-item">
                        <img class="section2-item-icon" src="../assets/image/tools/section2_icon3.svg" alt="" />
                        <p class="p1">
                            {{ $t('Tools.外汇EA策略执行器') }}
                        </p>
                    </div>
                </div>
            </section>
            <section class="section3">
                <h2 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.EBCTurbo账户分析系统2') }}</h2>
                <p class="p1">
                    {{ $t('Tools.EBC独家盈亏统计和历史回溯工具') }}
                </p>
                <div class="section3-content">
                    <div class="section3-item">
                        <img class="section3-img pc" src="../assets/image/tools/section3_icon1.png" alt="" />
                        <img class="section3-img mobile" src="../assets/image/tools/section3_icon1_m.png" alt="" />
                        <h3 :class="$t('common.fontFamilyTitle')"> {{ $t('Tools.净值收益曲线') }}</h3>
                    </div>
                    <div class="section3-item">
                        <div class="section3-img-box">
                            <div class="section3-item-text">{{ $t('Tools.收益率') }}</div>
                            <div class="section3-img-inner-box">
                                <div class="section3-img-inner-left">
                                    <div class="section3-item-text">{{ $t('Tools.最大回撤') }}</div>
                                    <div class="section3-item-text">{{ $t('Tools.标准差') }}</div>
                                </div>
                                <img class="section3-inner-img" src="../assets/image/tools/section3_icon2.png" alt="" />
                                <div class="section3-img-inner-right">
                                    <div class="section3-item-text">{{ $t('Tools.获利系数') }}</div>
                                    <div class="section3-item-text">{{ $t('Tools.夏普比率') }}</div>
                                </div>
                            </div>
                            <div class="section3-item-text">{{ $t('Tools.盈利交易') }}</div>
                        </div>
                        <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.六维评级图') }}</h3>
                    </div>
                    <div class="section3-item">
                        <img class="section3-img pc" src="../assets/image/tools/section3_icon3.png" alt="" />
                        <img class="section3-img mobile" src="../assets/image/tools/section3_icon3_m.png" alt="" />
                        <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.每日') }}</h3>
                    </div>
                </div>
                <div class="btn-box">
                    <a target="_blank" class="btn btn-t" :href="$t('Tools.url')">{{ $t('Tools.获取EBCTurbo') }}</a>
                </div>
            </section>
            <section class="section4">
                <h2 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.实用型技术指标集2') }}</h2>
                <p class="p1">
                    {{ $t('Tools.经过优化的常用技术指标') }}
                </p>
                <div class="section4-content">
                    <div class="section4-content-item">
                        <img class="section4-item-img" src="../assets/image/tools/section4_icon1.png" alt="" />
                        <div class="section4-item-content">
                            <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.同图商品叠加工具') }}</h3>
                            <p class="info1">
                                {{ $t('Tools.帮助投资者通过叠加两个商品的走势') }}
                            </p>
                        </div>
                    </div>
                    <div class="section4-content-item">
                        <img class="section4-item-img" src="../assets/image/tools/section4_icon2.png" alt="" />
                        <div class="section4-item-content">
                            <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.MACD专业指标') }}</h3>
                            <p class="info1">
                                {{ $t('Tools.提供比普通MACD更为精准的双线指标') }}

                            </p>
                        </div>
                    </div>
                    <div class="section4-content-item">
                        <img class="section4-item-img" src="../assets/image/tools/section4_icon3.png" alt="" />
                        <div class="section4-item-content">
                            <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.MTDriver盈亏统计指标') }}</h3>
                            <p class="info1">
                                {{ $t('Tools.该指标可协助投资者实时统计不同周期内的盈亏情况') }}

                            </p>
                        </div>
                    </div>
                    <div class="section4-content-item">
                        <img class="section4-item-img" src="../assets/image/tools/section4_icon4.png" alt="" />
                        <div class="section4-item-content">
                            <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.价格变动手机推送通知') }}</h3>
                            <p class="info1">
                                {{ $t('Tools.实时监控市场价格波动') }}

                            </p>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <a target="_blank" class="btn" :href="$t('Tools.url')">{{ $t('Tools.获取指标') }}</a>
                </div>
            </section>
            <section class="section5">
                <h2 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.外汇EA策略执行器2') }}</h2>
                <p class="p1">
                    {{ $t('Tools.基于高级算法自动执行EA交易策略') }}

                </p>
                <div class="section5-content">
                    <img class="section5-img" src="../assets/image/tools/section5_bg.png" alt="" />
                    <div class="section5-item">
                        <h3 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.定时下单EA软件') }}</h3>
                        <p class="info1">
                            {{ $t('Tools.通过MT4EA') }}
                        </p>
                    </div>
                </div>
            </section>
            <section class="section6">
                <h2 :class="$t('common.fontFamilyTitle')">{{ $t('Tools.EA交易常见问题') }}</h2>
                <qa-list :data="$t('Tools.qaList')"></qa-list>
            </section>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },

    created() {

    }
}
</script>

<style scoped>
.section1 {
    height: 333rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("../assets/image/tools/section1_bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
}

.section1 h1 {
    color: #fff;
    text-align: center;
    font-size: 40rem;
    font-style: normal;
    font-weight: 900;
    line-height: 48rem;
}

.section1 .p1 {
    margin-top: 25rem;
    color: #fff;
    text-align: center;
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 600rem;
}

.en .section1 .p1 {
    max-width: 1200rem;
}

.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 41rem;
    min-width: 200rem;
    border-radius: 2rem;
    background: #fff;
    padding: 14rem 20rem;
    color: #a52933;
    text-align: center;
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    transition: all 0.3s;
}

.btn:hover {
    background: #a52933;
    color: #fff;
}

.btn-light {
    color: #fff;
}

.btn-t {
    background: transparent;
}

.mt-52 {
    margin-top: 40rem;
}

.section2,
.section3,
.section4,
.section5,
.section6 {
    padding: 120rem 260rem;
}

.section5 {
    padding-bottom: 70rem;
}

.section3 h2,
.section4 h2,
.section5 h2,
.section6 h2 {
    color: #a52933;
    text-align: center;
    font-size: 36rem;
    font-style: normal;
    font-weight: 900;
    line-height: 1em;
}

.section3 .p1,
.section4 .p1,
.section5 .p1,
.section6 .p1 {
    margin-top: 38rem;
    color: #666;
    text-align: center;
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
    padding: 0 180rem;
}

.section2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 170rem;
}

.section2-img {
    flex-shrink: 0;
    width: 743rem;
    align-self: flex-start;
}

.section2-content {
    display: flex;
    flex-direction: column;
    gap: 25rem;
    align-items: flex-start;
}

.section2-item {
    display: flex;
    align-items: center;
    gap: 26rem;
}

.section2-item img {
    width: 86rem;
    height: 86rem;
    flex-shrink: 0;
}

.section2-item .p1 {
    color: #666;
    font-size: 18rem;
    font-weight: 400;
    line-height: normal;
}

.section3-content {
    display: flex;
    justify-content: space-between;
    gap: 184rem;
    margin-top: 100rem;
}

.section3-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 345rem;
    gap: 40rem;
}

.section3-img {
    width: 345rem;
    height: 345rem;
}

.section3-item h3 {
    color: #a52933;
    text-align: center;
    font-size: 18rem;
    font-style: normal;
    font-weight: 700;
}

.section3-img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 400rem;
    height: 345rem;
    gap: 7rem;
}

.section3-inner-img {
    flex-shrink: 0;
    width: 213rem;
    height: 240rem;
}

.section3-item-text {
    color: #666;
    font-size: 12rem;
    font-weight: 400;
}

.section3-img-inner-box {
    display: flex;
    gap: 5rem;
}

.section3-img-inner-left,
.section3-img-inner-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-shrink: 0;
    width: 85rem;
}

.section3-img-inner-left .section3-item-text {
    text-align: right;
}

.section3-img-inner-right .section3-item-text {}

.btn-box {
    margin-top: 110rem;
    display: flex;
    justify-content: center;
    gap: 25rem;
}

.btn {
    border: 1px solid #a52933;
}

.section3,
.section5 {
    background: linear-gradient(90deg,
            rgba(246, 246, 246, 0.5) 0%,
            rgba(217, 217, 217, 0) 100%);
}


.section4-content {
    margin-top: 100rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* 两列，等宽 */
    grid-template-rows: 1fr 1fr;
    /* 两行，等高 */
    gap: 138rem;
}

.section4-content-item {
    display: flex;
    gap: 35rem;
}

.section4-item-img {
    width: 263rem;
    height: 159rem;
    flex-shrink: 0;
}

.section4-item-content {
    display: flex;
    gap: 8rem;
    flex-direction: column;
}

.section4-item-content h3 {
    color: #a52933;
    font-size: 18rem;
    font-weight: 700;
    line-height: normal;
}

.section4-item-content .info1 {
    color: #6a6967;
    font-size: 18rem;
    font-weight: 400;
    line-height: normal;
}

.section5-content {
    margin-top: 100rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 37rem;
}

.section5-img {
    width: 501rem;
    height: 396rem;
}

.section5-item {
    max-width: 510rem;
    display: flex;
    gap: 8rem;
    flex-direction: column;
    margin-top: -70rem;
}

.section5-item h3 {
    color: #a52933;
    font-size: 18rem;
    font-weight: 700;
    line-height: normal;
}

.section5-item .info1 {
    color: #6a6967;
    font-size: 18rem;
    font-weight: 400;
    line-height: normal;
}


@media (max-width: 996px) {
    .section1 {
        /* background-size: 100% 100%; */
        background: url("../assets/image/tools/section1_bg_m.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        height: 443rem;
    }

    .en .section1 {
        height: 500rem;
    }

    .section2,
    .section3,
    .section4,
    .section5 {
        padding: 100rem 30rem;
    }

    .section6 {
        padding: 100rem 80rem;
    }

    .section3 h2,
    .section4 h2,
    .section5 h2,
    .section6 h2 {
        font-size: 44rem;
    }

    .section1 h1 {
        font-size: 56rem;
        line-height: normal;
    }

    .section1 .p1 {
        margin-top: 65rem;
        font-size: 24rem;
        max-width: 500rem;
    }

    .en .section1 .p1 {
        margin-top: 26rem;
        width: 690rem;
        font-size: 22rem;
    }

    .section3 .p1,
    .section4 .p1,
    .section5 .p1,
    .section6 .p1 {
        font-size: 24rem;
        padding: 0 30rem;
        line-height: normal;
    }

    .section2 {
        flex-direction: column;
        gap: 80rem;
    }

    .section2-content {
        gap: 35rem;
    }

    .section2-img {
        width: 660rem;
        align-self: center;
    }

    .section2-item .p1 {
        font-size: 24rem;
        width: 400rem;
    }

    .section2-item img {
        width: 102rem;
        height: 102rem;
    }

    .btn-box {
        margin-top: 80rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .btn {
        min-width: 334rem;
        height: 68rem;
        font-size: 24rem;
    }

    .section3-content {
        flex-direction: column;
        align-items: center;
        margin-top: 75rem;
        gap: 70rem;
    }

    .section3-img {
        width: 450rem;
        height: unset;
        gap: 32rem;
    }

    .section3-item {
        width: auto;
    }

    .section3-img-box {
        height: auto;
        width: auto;
    }

    .section3-item h3 {
        font-size: 24rem;
    }

    .section3-item-text {
        font-size: 18rem;
    }

    .section3-inner-img {
        width: 260rem;
        height: unset;
    }

    .section3-img-inner-left,
    .section3-img-inner-right {
        width: 140rem;
    }

    .section4-content {
        display: flex;
        flex-direction: column;
        margin-top: 80rem;
        grid-template-columns: 1fr;
        /* 两列，等宽 */
        grid-template-rows: 1fr 1fr 1fr 1fr;
        /* 两行，等高 */
        gap: 70rem;
    }

    .section4-item-content .info1,
    .section4-item-content h3 {
        font-size: 22rem;
    }

    .section5-content {
        margin-top: 80rem;
        flex-direction: column;
    }

    .section5-img {
        width: 405rem;
        height: unset;
    }

    .section5-item h3,
    .section5-item .info1 {
        font-size: 24rem;
        text-align: center;
    }

    .section5-item {
        margin-top: -40rem;
        max-width: 550rem;
    }

}
</style>
